import React from 'react'
import { makeStyles } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { useAdvisorStatusSummary } from '../../../../api/users'
import { useAdvisorUserDetails } from './AdvisorUserFormContext'

const useStyles = makeStyles((theme) => ({
  statusBadge: {
    backgroundColor: 'var(--color-primary-500)',
    color: 'var(--color-primary-050)',
    padding: '4px 8px',
    borderRadius: 'var(--border-radius-md)',
    fontWeight: theme.typography.weights.semibold,
    fontSize: theme.typography.fontSizes.sm
  },
  reset: {
    display: 'flex',
    maxWidth: '200px'
  }
}))

function ExperienceSection () {
  const { user } = useAdvisorUserDetails()
  const classes = useStyles()
  const { data, isLoading } = useAdvisorStatusSummary(user.userId)

  if (isLoading) {
    return <div className={classes.reset} />
  }

  return (
    <FadeIn className={classes.reset}>
      <div className={classes.statusBadge}>
        {data.statusSummary.status}
      </div>
    </FadeIn>
  )
}

export default ExperienceSection
